import React, { useState } from 'react'
import styled from 'styled-components'
import Burger from './Burger'
import './Navbar.scss'
import logo from './../../assets/onesforte.png'
import textLogo from './../../assets/text-logo-white.png'

const Nav = styled.nav`
    height: 70px;
    /* border-bottom: 2px solid #f1f1f1; */
    
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Roboto';
    background-color: transparent;
    transition: all 300ms;
    /* width: 100%; */
    padding: 0 5px 0 20px;
    max-width: 1200px;
    margin: 0 auto;

    .logo {
        padding: 15px 0;
    }

    @media (max-width: 768px) {
        padding: 0 20px;
        /* justify-content: space-between; */
    }
`

const Navbar = () => {

    const [navbar, setNavbar] = useState(false)
    const changeNavbarBg = () => {
        if(window.scrollY >= 80) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }
    window.addEventListener('scroll', changeNavbarBg)
    
    return (
        <div className={navbar ? 'navbar' : 'container'}>
            <Nav >
                <div className="logo">
                    <div className="logo-main">
                        <img src={logo} alt="ones forte logo"/>
                    </div>
                    <div className="logo-container">
                        <img src={textLogo} alt="ones forte logo"/>
                        {/* <span className="logo-name">One's Forte Co., LTD</span> */}
                        {/* <span className="logo-subname">Construction and Trading Corp.</span> */}
                    </div>

                </div>
                <Burger />
                
            </Nav>
        </div>
        
    )
}

export default Navbar
